<template>
  <div class="contact-import-upload-step">
    <div class="box">
      <h2 class="title is-5">Seleccionar archivo</h2>
      <p class="subtitle is-6">
        Selecciona un archivo Excel o CSV para importar contactos.
      </p>

      <div
        class="upload-zone"
        :class="{ 'is-dragover': isDragOver }"
        @dragover.prevent="isDragOver = true"
        @dragleave.prevent="isDragOver = false"
        @drop.prevent="handleDrop"
      >
        <p class="mb-3">Arrastra el archivo aquí o selecciónalo manualmente.</p>

        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls,.csv"
          class="is-hidden"
          @change="handleFileChange"
        />

        <b-button
          type="is-primary"
          icon-pack="fas"
          icon-left="file-upload"
          @click="$refs.fileInput.click()"
        >
          Elegir archivo
        </b-button>
      </div>

      <div v-if="file" class="notification is-success is-light mt-4">
        <strong>Archivo seleccionado correctamente</strong>
        <br />
        {{ file.name }}
        <br />
        Tamaño: {{ formatSize(file.size) }}
      </div>

      <div class="mt-4">
        <b-button
          type="is-light"
          icon-pack="fas"
          icon-left="download"
          @click="$emit('download-template')"
        >
          Descargar plantilla Excel
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactImportUploadStep",

  props: {
    file: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isDragOver: false,
    };
  },

  methods: {
    handleFileChange(event) {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        this.$emit("selected", selectedFile);
      }
    },

    handleDrop(event) {
      this.isDragOver = false;

      const selectedFile = event.dataTransfer.files[0];

      if (selectedFile) {
        this.$emit("selected", selectedFile);
      }
    },

    formatSize(bytes) {
      if (!bytes) {
        return "0 KB";
      }

      const sizeInKb = bytes / 1024;

      if (sizeInKb < 1024) {
        return `${sizeInKb.toFixed(1)} KB`;
      }

      return `${(sizeInKb / 1024).toFixed(1)} MB`;
    },
  },
};
</script>

<style scoped>
.upload-zone {
  border: 2px dashed #3273dc;
  border-radius: 6px;
  padding: 40px;
  text-align: center;
  background: #f4f9ff;
}

.upload-zone.is-dragover {
  background: #e8f2ff;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}
</style>